/**
 * Created by Nico on 05.07.2016.
 */
define('modules/settings/unit/UnitController',[
        'modules/module',
        'settings',
        'modules/basemodule/controllers/EntityListController'
    ],
    function (module) {
        'use strict';
        module.controller('UnitController', ['$scope', '$controller', 'BASE_TEMPLATES_PATH',
            function ($scope, $controller, BASE_TEMPLATES_PATH) {

                angular.extend(this, $controller('EntityListController', {
                    $scope: $scope
                }));

                $scope.tableOptions.fields = [
                    {
                        id: 'NAME',
                        heading:    'Name',
                        attribute:  'name'
                    },
                    {
                        id: 'UNIT',
                        heading:    'Einheit',
                        attribute:  'unit'
                    }
                ];
                $scope.formState = 'root.unit';

                $scope.init('Unit');
            }
        ]);
    }
);
